import { Application } from '@hotwired/stimulus'
import { notification } from 'antd'

const application = Application.start()

declare global {
  interface Window {
    Stimulus: Application
    notification: typeof notification
  }
}

window.Stimulus = application
window.notification = notification
// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
